import { createAction, props } from '@ngrx/store';
import {UserInvite} from "../../../shared/models/user-invite.model";

export const loadInvitedUsers = createAction('[UserInviteList Component] Load InvitedUsers');
export const loadInvitedUsersSuccess = createAction(
  '[UserInviteList Data Access] InvitedUsers Load Success',
  props<{ userInvites: UserInvite[] }>()
);

export const loadInvitedUsersFailure = createAction(
  '[UserInviteList Data Access] InvitedUsers Load Failure',
  props<{ error: string }>()
);

export const inviteUser = createAction(
  '[UserInviteList Component] Invite User',
  props<{ userInvite: UserInvite }>()
);

export const inviteUserSuccess = createAction(
  '[UserInviteList DataAccess] UserInvite Success',
  props<{ userInvite: UserInvite, successMessage: string }>()
);

export const inviteUserFailure = createAction(
  '[UserInviteList DataAccess] UserInvite Failure',
  props<{ error: string }>()
);

export const cancelUserInvite = createAction(
  '[UserInviteList Component] Cancel UserInvite',
  props<{ userInviteId: number }>()
);

export const cancelUserInviteSuccess = createAction(
  '[UserInviteList DataAccess] UserInvite Cancel Success',
  props<{ userInvite: UserInvite, successMessage: string }>()
);

export const cancelUserInviteFailure = createAction(
  '[UserInviteList DataAccess] UserInvite Cancel Failure',
  props<{ error: string }>()
);

